import LinkWrapper from "../../../components/Nestable/LinkWrapper/LinkWrapper";
import cn from "classnames";
import s from "../Footer.module.scss";
import Icon from "../../Icon";

type Props = {
  locale: string;
  privacyPolicyText: string;
  privacyPolicyLink: string;
  termsOfUseText: string;
  termsOfUseLink: string;
  copyright: string;
  allRightsReserved: string;
  icpLicense: string;
  aiTranslationNotice: string;
};

const getCurrentYear = (): number => {
  return new Date().getFullYear();
};

const FooterFooter = ({
  locale,
  privacyPolicyText,
  privacyPolicyLink,
  termsOfUseText,
  termsOfUseLink,
  copyright,
  allRightsReserved,
  icpLicense,
  aiTranslationNotice,
}: Props) => {
  return (
    <>
      <ul className={cn(s.footerFooter)}>
        <li>
          {privacyPolicyText && privacyPolicyLink && (
            <LinkWrapper
              href={privacyPolicyLink}
              text={privacyPolicyText}
              variant={"light"}
            />
          )}
          {termsOfUseText && termsOfUseLink && (
            <LinkWrapper
              href={termsOfUseLink}
              text={termsOfUseText}
              variant={"light"}
            />
          )}
        </li>
        <li>
          <span>
            {copyright} 2001-{getCurrentYear()} Tobii &bull; {allRightsReserved}
          </span>
          {locale == "zh" && <span> &bull; {icpLicense} </span>}
        </li>
      </ul>
      {locale == "fr" || locale == "de" || locale == "es" ? (
        <>
          <div className={s.aiNotice}>
            <Icon icon={"warning"} width={18} />
            <span>{aiTranslationNotice}</span>
          </div>
        </>
      ) : null}
    </>
  );
};

export default FooterFooter;
